import React from 'react';
import cx from 'classnames';
import { StyledModal } from '../StyledModal';
import { SharedItems } from './components/SharedItems';
import styles from './style.module.css';

interface Props {
  typeShared: string;
  isOpenModal: boolean;
  controlModal: () => void;
  dataShare: any;
}
export const SharedModal = ({ dataShare, typeShared, isOpenModal, controlModal }: Props) => {
  const sharedBox = cx('ma32', styles.sharedBox);
  return (
    <StyledModal isOpen={isOpenModal} closeModal={controlModal}>
      <div className={sharedBox}>
        <div className="mb24">
          <p className="f26 abbey fw2 ma0">Compartilhar</p>
          <p className="f26 fw7 red ma0">{typeShared}</p>
        </div>

        <SharedItems dataShare={dataShare} />
      </div>
    </StyledModal>
  );
};
